<div class="card-title">Управление навыком</div>
<div class="skill-info">
  <div class="skill-id"></div>
  <input [(ngModel)]="skill.name" placeholder="Название навыка"/>
  <div class="skill-controls">
    <button (click)="goBack()">Назад</button>
    <button (click)="save()">Сохранить</button>
  </div>
</div>
<div class="skill-box">
  <div class="skills-title">Сотрудники с этим навыком</div>
  <div class="skill" *ngFor="let employee of employees" (click)="changeEmployeeSkill(employee.id)">
    <img src="assets/icons/done.svg" *ngIf="employeeIdsHasSkill.includes(employee.id); else noSkill">
    <ng-template #noSkill><img class="square-img" src="assets/icons/icon_warning_red.svg"></ng-template>
    <div class="skill-name"> {{employee.name}}</div>
  </div>
</div>
